export const LEVEL02_BGM_KEY = "level02-neon-brawler";
export const LEVEL02_BGM_URL = "/assets/audio/level02-neon-brawler.mp3";
export const LEVEL02_BOSS_BGM_KEY = "level02-elon-neon-inferno";
export const LEVEL02_BOSS_BGM_URL = "/assets/audio/level02-elon-neon-inferno.mp3";
export const LEVEL02_BGM_VOLUME = 0.42;
export const LEVEL02_BGM_FADE_MS = 480;

export function shouldLoopLevel02Theme(input: {
  levelIndex: number;
  activeWaveId: string | null;
  practiceBossStart: boolean;
  silencedForBoss: boolean;
}): boolean {
  if (input.levelIndex !== 1) return false;
  if (input.practiceBossStart) return false;
  if (input.silencedForBoss) return false;
  return input.activeWaveId !== "boss";
}

export function shouldLoopLevel02BossTheme(input: {
  levelIndex: number;
  activeWaveId: string | null;
  practiceBossStart: boolean;
  silencedForBoss: boolean;
}): boolean {
  if (input.levelIndex !== 1) return false;
  if (input.practiceBossStart) return true;
  if (input.silencedForBoss) return true;
  return input.activeWaveId === "boss";
}
